export function isEmpty(value: Record<string, unknown>): boolean {
  return Object.keys(value).length === 0;
}
